import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:10000';

// Helper to get auth token
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// Helper to create auth header
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

// Register a new tracker
export const registerTracker = async (trackerData) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trackers/register`,
      trackerData,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all trackers
export const getAllTrackers = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/trackers`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get tracker by ID
export const getTrackerById = async (trackerId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/trackers/${trackerId}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update tracker
export const updateTracker = async (trackerId, trackerData) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/trackers/${trackerId}`,
      trackerData,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete tracker
export const deleteTracker = async (trackerId) => {
  try {
    const response = await axios.delete(
      `${API_URL}/api/trackers/${trackerId}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Send command to tracker
export const sendCommand = async (trackerId, command) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/trackers/${trackerId}/command`,
      { command },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get logs for a tracker
export const getTrackerLogs = async (trackerId) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/trackers/${trackerId}/logs`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get command statistics
export const getCommandStats = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/trackers/stats/commands`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all logs (admin only)
export const getAllLogs = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/api/trackers/logs/all`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get all bookmarks (to link with trackers)
export const getAllBookmarks = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/auth/bookmarks`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
